var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc-classes"},[_c('div',{staticClass:"tc-classes-body",class:_vm.classClasses}),(_vm.isShowClassIcon)?_c('v-icon',{staticClass:"blue--text classes-icon",attrs:{"small":""}},[_vm._v("local_offer")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }